import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "318",
  height: "318",
  viewBox: "366 495 318 318"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M466.8 728.3c-18.3-2.3-34.7-14.2-45.2-27.3-4.5 9.2-7 19.2-7.3 29.5-1.2 40 32.3 72 72.3 72s72.5-31.6 72.1-72.5c0 0-74.2.6-91.9-1.7"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M402.4 734.8c-1.2-49.1 38.6-84.4 83.9-84.4h31.2c22.9 0 41.4-18.5 41.4-41.4s-18.5-41.4-41.4-41.4h-18.1c-56.8 0-102.8 46-102.9 102.8v42.9c0 8 3 25.1 7.6 37.1 0 .1.1.1.2.1s.1-.1.1-.2c-1.3-5.1-1.9-10.3-2-15.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M612.1 495c-22.9 0-41.5 18.6-41.5 41.4v194.1c-.1 39.6-27.7 73.9-66.5 82.2-.1 0-.1.1-.1.1 0 .1.1.1.1.1h43.7c56.8 0 105.7-46 105.7-102.9V536.5c0-22.9-18.5-41.5-41.4-41.5"
    }, null, -1)
  ])))
}
export default { render: render }